
import React from 'react';
import FormFieldCard from './FormFieldCard';
import { SignupFormField } from '@/schemas/signupFormSchema';

export interface FieldsListProps {
  fields: SignupFormField[];
  onFieldUpdate: (updatedField: SignupFormField) => void;
  onFieldDelete: (fieldId: string) => void;
}

export const FieldsList: React.FC<FieldsListProps> = ({ 
  fields,
  onFieldUpdate,
  onFieldDelete
}) => {
  return (
    <div className="space-y-3">
      {fields.map((field) => (
        <FormFieldCard
          key={field.id}
          field={field}
          onUpdate={onFieldUpdate}
          onDelete={() => onFieldDelete(field.id)}
        />
      ))}
    </div>
  );
};
